import { Pipe, PipeTransform } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';

/*
This pipe returns 2 differnt types of objects depending upon the input.
If the values are strings (These are badge.ids):
["Test Badge - Vegas", "Reply_1", "THE_TRUCKER", "TP_5", "TP_Fuel", "Flagged_Post", "Miles_250", "Parking_Full", "Lousiville", "Profile", "2019_OperationSafeDriver", "Orlando"]
Then a full list of all badge objects is required (second parameter).
It will categorize badges by type (admin, location, other), then return the strings
which intersect with the values.

Otherwise (the values is an array of badge objects), then
the pipe will return an array of objects based upon the filter (args[0])

*/
@Pipe({
  name: 'badgesFilter',
})
export class BadgesFilterPipe implements PipeTransform {
  log = debug('app:BadgesFilterPipe');

  transform(values: any, ...args) {
    const filter = args[0];
    const badges = args[1];
    const limit = args[2];
    this.log('limit: ', limit);
    if (this.isArrayOfStrings(values)) {
      // These are the badges earned
      const badgesIdsByType = this.getBadgeIdsByType(badges);
      if (filter === 'admin') {
        return _.intersection(badgesIdsByType.adminManaged, values);
      } else if (filter === 'location') {
        const int = _.intersection(badgesIdsByType.locations, values);
        return int.slice(0, limit);
      } else if (filter === 'leaderboard') {
        return _.intersection(badgesIdsByType.leaderboard, values);
      } else {
        return _.intersection(badgesIdsByType.other, values);
      }
    } else {
      /* values are an Array of badge objects */
      return this.filteringBadges(filter, values, limit);
    }
  }

  isArrayOfStrings(values) {
    return _.isString(_.first(values));
  }
  getBadgeIdsByType(badges) {
    const r = {
      adminManaged: [],
      locations: [],
      leaderboard: [],
      other: [],
    };
    _.forEach(badges, badge => {
      if (badge.adminManaged) {
        r.adminManaged.push(badge.id);
      } else if (badge.location) {
        r.locations.push(badge.id);
      } else if (badge.leaderboard) {
        r.leaderboard.push(badge.id);
      } else {
        r.other.push(badge.id);
      }
    });
    return r;
  }
  filteringBadges(filter, badges, limit) {
    if (filter === 'admin') {
      return _.filter(badges, 'adminManaged');
    } else if (filter === 'location') {
      const f = _.filter(badges, 'location');
      return f.slice(0, limit);
    } else if (filter === 'leaderboard') {
      return _.filter(badges, 'leaderboard');
    } else {
      return _.filter(badges, function(b) {
        return !b.location && !b.adminManaged && !b.leaderboard;
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/badges-filter/badges-filter.ts